export const distanceTo = (a, b) => Math.sqrt((a.x - b.x) ** 2 + (a.y - b.y) ** 2)
